import { useEffect, useState } from "react";
import { T } from "@/components/T";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { useBookmarks } from "@/context/BookmarkContext";
import { fetchContent } from "@/lib/api";
import KnowledgeCard from "@/components/KnowledgeCard";
import { Bookmark } from "lucide-react";

export default function Bookmarks() {
  const { t } = useLang();
  const { bookmarks } = useBookmarks();
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetchContent({ limit: 200 }).then(setItems).catch(() => {});
  }, []);

  const saved = items.filter((i) => bookmarks.includes(i.slug));

  return (
    <div className="mx-auto max-w-7xl px-5 py-14 md:px-8 md:py-20">
      <div className="mb-12 flex items-center gap-3">
        <Bookmark className="h-6 w-6 text-saffron" />
        <h1 className="font-serif-latin text-4xl text-ink">{t("bookmarks")}</h1>
      </div>
      {saved.length === 0 ? (
        <div className="border border-line bg-surface py-20 text-center">
          <p className="text-ink-3"><T>You haven't saved any knowledge yet.</T></p>
          <Link to="/explore" className="mt-4 inline-block text-saffron link-underline"><T>Explore knowledge →</T></Link>
        </div>
      ) : (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {saved.map((it) => (
            <KnowledgeCard key={it.slug} item={it} showImage />
          ))}
        </div>
      )}
    </div>
  );
}
